import script from "./analysingPhotoLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./analysingPhotoLoader.vue?vue&type=script&setup=true&lang=js"

import "./analysingPhotoLoader.vue?vue&type=style&index=0&id=60054c96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60054c96"]])

export default __exports__